<template>
    <div class="notificacion-form">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" width="500" scrollable>
                    <v-card>
                        <v-toolbar card prominent color="primary" dark>
                            <v-toolbar-title class="body-2">{{ this.formTitle }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="cancelForm()">
                                <v-icon medium>fa-close</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-flex>
                            <v-alert
                                v-model="showErrorDataLoadedAlert"
                                type="error"
                                dismissible
                                transition="scale-transition"
                                dark
                            >
                                No se han podido cargar todos los datos necesarios para este formulario, intente cargar
                                el formulario nuevamente.
                            </v-alert>
                        </v-flex>

                        <v-card-text>
                            <v-form ref="notificacionForm" v-model="validTarea">
                                <v-container fluid grid-list-xl>
                                    <v-layout align-center wrap>
                                        <v-flex xs12 sm12>
                                            <v-autocomplete
                                                v-model="notificacionItem.categoria"
                                                :items="BD_TABLES"
                                                label="Categoría"
                                                :rules="categoriaRules"
                                                :error-messages="categoriaErrors"
                                                @blur="categoriaErrors = []"
                                                @keypress.enter.prevent=""
                                            >
                                            </v-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Cancelar</v-btn>
                            <v-btn
                                color="success"
                                flat
                                @click="saveForm()"
                                :disabled="disableSaveButton"
                                :loading="loading"
                                >Guardar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
    props: {
        formTitle: { type: String, default: null },
        initialItem: { type: Object, default: null }
    },
    data() {
        return {
            loading: false,
            validTarea: false,
            notificacionItem: {
                categoria: ""
            },

            //validaciones
            categoriaRules: [v => !!v || "Debe proporcionar una categoría"],
            categoriaErrors: [],

            showErrorAlert: false,

            //saber si se cargaron todos los datos necesarios para el formulario
            showErrorDataLoadedAlert: false
        }
    },
    computed: {
        ...mapGetters(["BD_TABLES"]),

        isNewRecord() {
            return this.initialItem === null
        },

        showForm: {
            get: function() {
                return true
            },
            set: function() {
                return this.cancelForm()
            }
        },

        disableSaveButton() {
            return this.loading || !this.validTarea
        }
    },

    methods: {
        saveForm() {
            this.loading = true
            this.$refs.notificacionForm.validate()

            if (this.validTarea) {
                let notificacion = {
                    categoria: this.notificacionItem.categoria
                }

                if (!this.isNewRecord) {
                    notificacion.id = this.notificacionItem.id
                }

                this.$store
                    .dispatch(this.isNewRecord ? "ADD_TIPO_NOTIFICACION" : "UPDATE_TIPO_NOTIFICACION", notificacion)
                    .then(result => {
                        if (!result) {
                            //no hay coneccion con el servidor
                            this.loading = false
                        }
                        if (result === null || result.status === 404 || result.status === 500) {
                            //cerrar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe
                            this.$emit("formCanceled")
                        } else {
                            // El backend devolvió error de validación, pasando los errores a los campos correspondientes
                            let { data, status } = result
                            if (status === 422) {
                                data.forEach(error => {
                                    if (error.field === "nombre") {
                                        this.nombreErrors.push(error.message)
                                    }
                                })
                            }
                        }
                        this.loading = false
                    })
            } else {
                this.loading = false
            }
        },

        cancelForm() {
            this.$emit("formCanceled")
        }
    },

    created() {
        if (this.initialItem !== null) {
            // Cargando información del elemento a actualizar
            this.notificacionItem.id = this.initialItem.id
            this.notificacionItem.categoria = this.initialItem.categoria
        }
    }
}
</script>
